import IconButton from "components/atoms/button/IconButton";
import Headline from "components/atoms/headline/Headline";
import Icon from "components/atoms/icon/Icon";
import { IconType } from "lib/helpers/constants/iconTypes";
import { useTranslation } from "react-i18next";
import Layout2 from "./overview-Layouts/Layout2";
import EditLayout from "./edit-layout/EditLayout";
import { useState } from "react";
import { useLayouts } from "lib/hooks/queries/Dashboard/useLayouts";
import LoadingScreen from "components/atoms/loading-screen/LoadingScreen";
import Layout1 from "./overview-Layouts/Layout1";
import Layout3 from "./overview-Layouts/Layout3";
import Layout5 from "./overview-Layouts/Layout5";
import UpdatePendingsProcess from "../pendings/update-pendings-process/UpdatePendingsProcess";
import { usePending } from "lib/hooks/queries/Pendings/usePending";
import { useLeadById } from "lib/hooks/queries/Leads/useLeadById";
import UpdateLead from "../leads/update-lead/UpdateLead";
import UpdateAppointmentProcess from "../appointment-management/update-appointment/UpdateAppointmentProcess";
import { useAppointmentById } from "lib/hooks/queries/Appointment/useAppointmentById";
import { useCustomerById } from "lib/hooks/queries/Coustomer/useCustomerById";
import UpdateCustomerProcess from "../customers/update-customer-process/UpdateCustomerProcess";
import UpdateLeadAppPending from "../pendings/update-lead-app-pending/UpdateLeadAppPending";
import LoadingModal from "./loading-modal/LoadingModal";

const OverviewView = () => {

  const { t } = useTranslation();

  const [IsEditLayoutOpen, setIsEditLayoutOpen] = useState(false)

  const { data, isLoading } = useLayouts()

  const [IsEditing, setIsEditing] = useState(false)

  const [ModalData, setModalData] = useState<any>({ modalType: null, data: { id: undefined } })

  const [ModalStep, setModalStep] = useState(1)

  const {
    data: userData,
    isLoading: isLoadingFetchingUser
  } = usePending(ModalData?.modalType === 'pendings' ? ModalData.data.id : undefined);

  const {
    data: leadData,
    isLoading: isLoadingFetchingLead
  } = useLeadById(ModalData?.modalType === 'leads' ? ModalData.data.id : undefined);

  const {
    data: appData,
    isLoading: isLoadingFetchingApp
  } = useAppointmentById(ModalData?.modalType === 'appointments' ? ModalData.data.id : undefined);

  const {
    data: customerData,
    isLoading: isLoadingFetchingCustomer
  } = useCustomerById(ModalData?.modalType === 'customers' ? ModalData.data.id : undefined);


  const [ModalHasChanges, setModalHasChanges] = useState(false)

  const SubmitLayout = () => {
    setIsEditing(false)
  }

  if (isLoading) {
    return <LoadingScreen />
  }

  return (
    <div className="">
      <div className={`flex justify-between sm:items-center gap-4 mt-[46px] mb-[33px] flex-col sm:flex-row`}>
        <Headline title={t("Dashboard")} className="!my-[0px]" />
        {IsEditing && (
          <IconButton className="sm:ml-auto" icon={<Icon iconType={IconType.EDIT_ICON} color="white" />} onClick={() => setIsEditLayoutOpen(true)} >
            {t("Change Layout")}
          </IconButton>
        )}
        <IconButton icon={<Icon iconType={IconType.EDIT_ICON} color="white" />}
          onClick={() => {
            IsEditing
              ? SubmitLayout()
              : setIsEditing(true)
          }}
        >
          {IsEditing ? t("Save Changes") : t("Dashboard")}
        </IconButton>
      </div>
      <div className="space-y-5">
        {
          {
            'Layout 1': <Layout1 isEditing={IsEditing} data={data} setModalData={setModalData} />,
            'Layout 2': <Layout2 isEditing={IsEditing} data={data} setModalData={setModalData} />,
            'Layout 3': <Layout3 isEditing={IsEditing} data={data} setModalData={setModalData} />,
            'Layout 4': <Layout5 isEditing={IsEditing} data={data} setModalData={setModalData} />,
            // 'Layout 5': <Layout5 isEditing={IsEditing} data={data} />,
            // 'Layout 6': <Layout6 isEditing={IsEditing} data={data} />,
          }[((data as any)?.layout_id) as string]
        }


      </div>

      {/* ///////////////////////
        Modals
//////////////////////// */}
      <LoadingModal 
        hocClasses={{
          modalClassName: `sm:max-w-[900px] sm:w-full w-full `,
        }}
        hocisOpen={isLoadingFetchingApp || isLoadingFetchingLead || isLoadingFetchingCustomer}
        hocToggleModal={() => {}}
        hocCurrentStep={1}
        hocTitle=""
        
      />
      <EditLayout
        activeLayout={(data as any)?.layout_id}
        hocisOpen={IsEditLayoutOpen}
        hocToggleModal={() => setIsEditLayoutOpen(!IsEditLayoutOpen)}
        hocCurrentStep={1}
        hocClasses={{
          modalClassName: `sm:max-w-[900px] sm:w-full w-full `,
        }}
        hocTitle="Dashboard"
        onConfirm={() => setIsEditLayoutOpen(false)}
      />
      <UpdatePendingsProcess
        userData={userData}
        setCurrentUpdatePending={setModalStep}
        updateCurrentPending={ModalStep}
        isLoadingFetchingUser={isLoadingFetchingUser}
        showToCommentsBackButton={true}
        showToCommentsConfirm={true}
        hocClasses={{
          modalClassName:
           ModalStep === 1 || ModalStep === 6
              ? "sm:w-[600px] md:max-w-[600px] sm-md:max-w-[600px] lg:min-w-[973px] 2xl:w-[948px]"
              : ModalStep === 2
                ? "sm:max-w-[467px]   md:min-w-[467px] lg:w-[467px]"
                : ModalStep === 3
                  ? "sm:w-[600px] md:max-w-[600px]  sm-md:max-w-[600px]   lg:min-w-[894px]"
                  : ModalStep === 4
                    ? "sm:w-[600px] md:max-w-[600px]  sm-md:max-w-[600px] lg:min-w-[894px]"
                    : ModalStep === 5
                      ? "sm:w-[600px] md:max-w-[600px]  sm-md:max-w-[600px] 2xl:min-w-[930px]"
                      : "",
            titleClassName: ModalStep === 6 ? "ml-[35px]" : ""

        }}
        hocCurrentStep={ModalStep}
        hocToggleModal={() => setModalData({ modalType: null, data: { id: undefined } })}
        hocisOpen={ModalData?.modalType === "pendings"}

        setHocCurrentStep={setModalStep}
        clearData={true}
        hocTitle={
            ModalStep === 1
              ? ""
              : ModalStep === 2
                ? t("Upload File")
                : ModalStep === 6
                  ? t("Products")
                  : ""
          }
      />
      <UpdateLead
        setHocCurrentStep={setModalStep}
        hocCurrentStep={ModalStep}
        onConfirm={() => { setModalData({ modalType: null, data: { id: undefined } }) }}
        setFormCurrentStep={setModalStep}
        formCurrentStep={ModalStep}
        hocisOpen={ModalData?.modalType === "leads" && leadData}
        hocToggleModal={() => setModalData({ modalType: null, data: { id: undefined } })}
        setHasChanges={setModalHasChanges}
        hocHasChanges={ModalHasChanges}
        hocTitle={
          ModalStep === 1
            ? ""
            : ModalStep === 2
              ? ""
              : ""
        }
        hocClasses={{
          modalClassName: `${`sm:max-w-[570px] sm:w-full w-full ${ModalStep === 1 || ModalStep === 4 || ModalStep === 5
            ? "md:min-w-[750px] lg:min-w-[1000px] xl:min-w-[1200px] 2xl:min-w-[1200px]"
            : ModalStep === 2
              ? "!w-[462px]"
              : ModalStep === 3
                ? "text-[100px]  md:min-w-[570px] lg:min-w-[563px] w-full"
                : ModalStep === 4
                  ? "md:min-w-[750px] lg:min-w-[1000px] xl:min-w-[1200px] 2xl:min-w-[1200px]"
                  : ""
            }`}`
        }}
        lead={leadData?.data}
      />

      <UpdateAppointmentProcess
        themeColors={{ primary: 'var(--theme)' }}
        clearData={true}
        hocClasses={{
          modalClassName: `${`sm:max-w-[570px] sm:w-full w-full ${ModalStep === 1
            ? "md:min-w-[750px] lg:min-w-[1000px]  xl:min-w-[1200px] 2xl:min-w-[1290px]"
            : ModalStep === 2
              ? "md:max-w-[770px]  md:w-[993px] lg:max-w-[1200px] xl:max-w-[1200px] 2xl:min-w-[1200px] !w-full"
              : ModalStep === 3
                ? "md:min-w-[572px] md:w-[572px] lg:w-[572px] xl:w-[572px] 2xl:min-w-[572px]"
                : ModalStep === 4
                  ? "md:min-w-[751px] md:w-[751px] lg:w-[751px] xl:w-[751px] 2xl:min-w-[751px]"
                  : ModalStep === 5
                    ? "md:min-w-[750px] md:w-[903px] lg:w-[903px] xl:w-[903px] 2xl:min-w-[903px]"
                    : ModalStep === 6
                      ? "md:min-w-[750px] md:w-[903px] lg:w-[903px] xl:w-[903px] 2xl:min-w-[903px]"
                      : ModalStep === 7
                        ? "md:min-w-[750px] md:w-[903px] lg:w-[903px] xl:w-[903px] 2xl:min-w-[903px]"
                        : ModalStep === 8
                          ? "md:min-w-[676px] md:w-[676px] lg:w-[676px] xl:w-[676px] 2xl:min-w-[676px]"
                          : ModalStep === 9
                            ? "md:min-w-[632px] md:w-[632px] lg:w-[632px] xl:w-[632px] 2xl:min-w-[632px]"
                            : ModalStep === 10
                              ? "md:min-w-[563px] md:w-[563px] lg:w-[563px] xl:w-[563px] 2xl:min-w-[563px]"
                              : ModalStep === 11
                                ? "md:min-w-[563px] md:w-[563px] lg:w-[563px] xl:w-[563px] 2xl:min-w-[563px]"
                                : ModalStep === 12
                                  ? "sm:w-[484px] md:w-[484px] lg:w-[484px] xl:w-[484px] 2xl:w-[484px] w-full"
                                  : ModalStep === 13
                                    ? "md:min-w-[750px] lg:w-[973px]"
                                    : "md:min-w-[750px] md:w-[900px] lg:w-[900px] xl:w-[900px] 2xl:min-w-[900px]"
            }`}`
        }}
        data={appData?.data}
        currentStep={ModalStep}
        hocCurrentStep={ModalStep}
        onConfirm={() => { setModalData({ modalType: null, data: { id: undefined } }) }}
        hocToggleModal={() => { setModalData({ modalType: null, data: { id: undefined } }) }}
        hocisOpen={ModalData?.modalType === "appointments" && appData}
        onCancel={() => { setModalData({ modalType: null, data: { id: undefined } }) }}
        setHocCurrentStep={setModalStep}
        showStatusButton={true}
        showDigitalButton={false}
        setCurrentFormStep={setModalStep}
        setIsUpdateModalOpen={setModalData as any}
      />

      <UpdateCustomerProcess
        setIsModalOpen={setModalData as any}
        themeColors={{ primary: 'var(--theme)' }}
        hocTitle={`
            ${ModalStep === 2
            ? t(`Add New Product`)
            : ModalStep === 3
              ? t(`Upload file`)
              : ModalStep === 4
                ? ""
                : ModalStep === 8
                  ? t("Add New Relation")
                  : ModalStep === 9
                    ? t("Submit Application")
                    : ""
          }
            `}
        data={customerData?.data}
        hocClasses={{
          modalClassName: `${`sm:max-w-[570px] sm:w-full w-full ${ModalStep === 1
            ? "md:min-w-[750px] lg:min-w-[1000px] xl:min-w-[1200px] 2xl:min-w-[1200px]"
            : ModalStep === 2
              ? "w-full !max-w-[760px]"
              : ModalStep === 3
                ? "sm:max-w-[467px]  md:min-w-[467px] lg:w-[467px]"
                : (ModalStep === 4 || ModalStep === 5)
                  ? "md:min-w-[750px]  lg:w-[973px]"
                  : (ModalStep === 6 || ModalStep === 7)
                    ? "md:min-w-[676px] md:w-[676px] lg:w-[676px] xl:w-[676px] 2xl:min-w-[676px]"
                    : ModalStep === 8
                      ? "sm:max-w-[430px] md:min-w-[430px] lg:min-w-[430px] xl:min-w-[430px] 2xl:min-w-[430px]"
                      : (ModalStep === 9 || ModalStep === 10)
                        ? "!max-w-[950px] w-full"
                        : ""
            }`}`,
          titleClassName: (ModalStep === 9 || ModalStep === 10) ? "ml-[35px]" : "",

        }}
        hocToggleModal={() => { setModalData({ modalType: null, data: { id: undefined } }) }}
        onConfirm={() => { setModalData({ modalType: null, data: { id: undefined } }) }}
        hocisOpen={ModalData?.modalType === "customers" && customerData}
        setHocCurrentStep={setModalStep}
        hocCurrentStep={ModalStep}
        setCurrentFormStep={setModalStep}
        currentStep={ModalStep}
        setStepOnClose={1}
      />
      <UpdateLeadAppPending
        userData={ModalData?.data}
        hocClasses={{
          modalClassName: "sm:w-[600px] md:max-w-[600px] sm-md:max-w-[600px] lg:min-w-[973px] 2xl:w-[948px]"
        }}
        hocCurrentStep={1}
        hocToggleModal={() => setModalData(undefined)}
        closeModal={() => setModalData(undefined)}
        hocisOpen={ModalData?.modalType === "appLead"}
        clearData={true}
        isOwn={ModalData?.isOwn}
      />
    </div >
  );
};

export default OverviewView;
